<div class="panel-heading">
	<button type="button" (click)= "onRemove()" class="close" style="color: #ffffff; margin-left: 10px; display: block">
		&times;
	</button>

	<!-- Minimize/Maximize Arrows -->
	<button (click)="showBody = !showBody" type="button" class="close" style="color: #ffffff; margin-left: 10px;">
		<i *ngIf="showBody" class="fa fa-angle-double-up"></i>
		<i *ngIf="!showBody" class="fa fa-angle-double-down"></i>
	</button>
	
	<h1 class="panel-title" style="display: inline-block; width: 90%">
		<div style="display: inline-block">
			<i class="fa fa-clock-o" ></i>&nbsp;TIME
		</div>
	</h1>
</div>

<div *ngIf="showBody" class="panel-body">
	<input id="time" class="form-control" type="time" [(ngModel)]="ruleCondition.propertyValue" />
</div>
